import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { CartDrawer } from "../components/CartDrawer";
import { ProductGrid } from "../components/ProductGrid";
import { BundleFeature } from "../components/BundleFeature";

export default function Catalog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#0D110D] min-h-screen" data-testid="catalog-page">
      <Navbar />
      <main className="pt-20">
        <BundleFeature />
        <ProductGrid />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
